export class Newsletter {
  firstName: string;
  lastName :string;
  email: string;
  privacy?: string;
}
